angular.module('bmsApp.marketing')
	.controller('MarketingSchemeOverviewCtrl', MarketingSchemeOverviewCtrl);

MarketingSchemeOverviewCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'InstanceSvc',
	'MarketingSchemeSvc',
	'DashboardApiSvc',
];

function MarketingSchemeOverviewCtrl($scope, $state, $q, InstanceSvc, MarketingSchemeSvc, DashboardApiSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
	});

	this.$onInit = () => {
		self.loading = true;

		MarketingSchemeSvc.read({id: $state.params.schemeId})
			.then((response) => {
				self.scheme = response.data.marketing_scheme;
				$scope.scheme = {
					name: self.scheme.label + ' (' + self.scheme.initiative.name + ')',
				};
				let params = {
					filter: {
						from: self.scheme.starts_at,
						to: self.scheme.ends_at,
						franchise: {
							id: InstanceSvc.instance.getFranchiseId(),
						},
						marketingScheme: {
							id: self.scheme.id,
						},
						view: 'remote',
						api_key: InstanceSvc.instance.getFranchiseApiKey(),
					},
				};

				DashboardApiSvc.initiativeMetrics(params).then((response) => {
					self.metrics = [];
					if (response.data.initiative_collection.length) {
						self.metrics = response.data.initiative_collection[0];
					}
					self.loading = false;
				});


			});
	};

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.submitClick = function () {

	};
}